import { Box, Typography } from "@mui/material";

type LabelProps = {
  title: string;
  value: string;
  color?: string;
};

const DisplayLabel = ({ title, value }: LabelProps) => {
  return (
    <Box>
      <Typography
        variant={"body1"}
        fontWeight={"600"}
        sx={{ textTransform: "capitalize" }}
      >
        {title}
      </Typography>
      <Typography
        variant={"subtitle1"}
        fontWeight={"400"}
        sx={{ textTransform: "capitalize" }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default DisplayLabel;
